/**
 * E08-F01-T06 — which origins the Outlook OAuth popup may report back from.
 *
 * The callback page is served BY THE API, and on this deploy the API is a
 * separate host from the SPA (`api.gap.eer.email` vs `gap.eer.email`). A widget
 * that accepts only `window.location.origin` therefore drops the popup's
 * `postMessage` and hangs on "Connecting…". Lives in its own module (not in
 * `OutlookConnect.tsx`) so the component file exports components only —
 * react-refresh requirement.
 */

/**
 * This window's origin plus the API origin. `apiBaseUrl` may be relative
 * (`/api`), in which case it resolves to the same origin and the list collapses
 * to one entry.
 */
export function acceptedMessageOrigins(
  location: { origin: string; href: string },
  apiBaseUrl: string,
): string[] {
  const origins = [location.origin];
  try {
    origins.push(new URL(apiBaseUrl, location.href).origin);
  } catch {
    /* a malformed base URL simply contributes nothing */
  }
  return [...new Set(origins)];
}
